
var id = "export-icon";
var markup = "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"export-icon\">\n<path d=\"M10.0858 2.00437C10.2903 2.00437 10.4626 2.07453 10.6025 2.21422L14.2365 5.84826C14.3764 5.98818 14.4464 6.16037 14.4464 6.3649C14.4464 6.57326 14.3773 6.74639 14.2393 6.88443C14.1012 7.02264 13.928 7.09162 13.7198 7.09162C13.5153 7.09162 13.3429 7.02162 13.2031 6.8817L10.8128 4.48561V12.906C10.8128 13.1065 10.7418 13.2779 10.5999 13.42C10.4578 13.562 10.2864 13.6331 10.0859 13.6331C9.8851 13.6331 9.71385 13.562 9.57184 13.42C9.42973 13.2779 9.35855 13.1065 9.35855 12.906V4.48561L6.96863 6.8817C6.82098 7.0217 6.64879 7.09162 6.45176 7.09162C6.25098 7.09162 6.07988 7.02053 5.93777 6.87857C5.79566 6.73654 5.72457 6.56506 5.72457 6.36451C5.72457 6.16756 5.79441 5.99521 5.93441 5.84779L9.56842 2.21375C9.70826 2.07375 9.88076 2.00391 10.0852 2.00391L10.0858 2.00437ZM17.2677 12.1789C17.4681 12.1789 17.6396 12.25 17.7815 12.392C17.9235 12.5341 17.9946 12.7055 17.9946 12.9062V15.8128C17.9946 16.4187 17.7847 16.9315 17.3645 17.3518C16.9368 17.7793 16.4257 17.9932 15.8314 17.9932H4.18561C3.59152 17.9932 3.07678 17.7812 2.64146 17.3571C2.21732 16.9218 2.00537 16.407 2.00537 15.8129V12.9062C2.00537 12.7054 2.07635 12.5341 2.21842 12.392C2.36053 12.25 2.53188 12.1789 2.7325 12.1789C2.93301 12.1789 3.10438 12.25 3.24648 12.392C3.38854 12.5341 3.45953 12.7055 3.45953 12.9062V15.8128C3.45953 16.0134 3.53051 16.1849 3.6727 16.327C3.81477 16.469 3.98602 16.5398 4.18672 16.5398H15.8323C16.0291 16.5398 16.1967 16.469 16.3349 16.327C16.473 16.1849 16.5421 16.0134 16.5421 15.8128V12.9062C16.5421 12.7054 16.6131 12.5341 16.7552 12.392C16.8973 12.25 17.0685 12.1789 17.2691 12.1789H17.2677Z\" fill=\"white\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
